import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';

import { Form, Tabs } from 'antd';
import { AntdPageHeader, ApplicationUIContext } from '@yuhuinc/ui-library';

import Configuration from './Form/Configuration';
import History from './Form/History';

import { Draft } from './Form/constants';

const PolicyForm = ({ formTitle, formName, formData, onClickBackButton, actionButtons }) => {
  const [form] = Form.useForm();
  const { isMobile } = useContext(ApplicationUIContext);

  const initialValues = {
    id: formData.id || undefined,
    status: formData.status || Draft,
    title: formData.title || undefined,
    rules: formData.rules || [],
    unit_ids: formData.unit_ids || [],
  };

  const defaultTabList = [
    {
      key: 'configuration',
      title: 'Configuration',
      content: <Configuration />,
    },
  ];

  const [activeTabKey, setActiveTabKey] = useState(defaultTabList[0].key);

  const renderFormFace = () => {
    if (!formData.id) {
      return <Configuration />;
    }
    return (
      <Tabs defaultActiveKey={activeTabKey} onChange={(key) => setActiveTabKey(key)}>
        <>
          {defaultTabList.map((tab) => (
            <Tabs.TabPane tab={tab.title} key={tab.key}>
              {tab.content}
            </Tabs.TabPane>
          ))}

          {formData.id && (
            <Tabs.TabPane tab={'History'} key={'history'}>
              <History />
            </Tabs.TabPane>
          )}
        </>
      </Tabs>
    );
  };

  return (
    <Form
      layout="vertical"
      size={isMobile && 'large'}
      form={form}
      name={formName}
      scrollToFirstError
      initialValues={initialValues}
    >
      <AntdPageHeader
        onBack={onClickBackButton}
        title={formTitle}
        status={initialValues.status}
        extra={actionButtons}
      >
        {renderFormFace()}
      </AntdPageHeader>
    </Form>
  );
};

PolicyForm.propTypes = {
  formTitle: PropTypes.string.isRequired,
  formName: PropTypes.string.isRequired,
  formData: PropTypes.object.isRequired,
  onClickBackButton: PropTypes.func.isRequired,
  actionButtons: PropTypes.node.isRequired,
};

export default PolicyForm;
